import {AssetList} from './helper/asset-loader';
import Vec3 from '../../shared/vec3';

const MODEL_DIRECTORY = '../assets/'

export const AssetIdentifiers = {
    MODEL_INFO: 'MODEL_INFO',
    MODEL_CACTUS: 'MODEL_CACTUS',
    MODEL_COUCH : 'MODEL_COUCH',
    MODEL_BOOKSHELF : 'MODEL_BOOKSHELF',
    MODEL_CATERING: 'MODEL_CATERING',
    MODEL_POUFS: 'MODEL_POUFS',
    MODEL_PLANTS: 'MODEL_PLANTS',
    MODEL_TABLETENNIS: 'MODEL_TABLETENNIS'
}

export const Assets: AssetList = {
    models: [
        {
            id: AssetIdentifiers.MODEL_INFO,
            directory: MODEL_DIRECTORY,
            fileName: 'info.stl',
            scaling: new Vec3(0.1,0.1,0.1)
        },
        {
            id: AssetIdentifiers.MODEL_CACTUS,
            directory: MODEL_DIRECTORY,
            fileName: 'cactus.glb',
            scaling: new Vec3(0.001,0.001,0.001)
        },
        {
            id: AssetIdentifiers.MODEL_COUCH,
            directory: MODEL_DIRECTORY,
            fileName: 'couch_themed.glb',
            scaling: new Vec3(0.001,0.001,0.001)
        },
        {
            id: AssetIdentifiers.MODEL_BOOKSHELF,
            directory: MODEL_DIRECTORY,
            fileName: 'modern_shelf_themed.glb',
            scaling: new Vec3(0.1,0.1,0.1)
        },
        {
            id: AssetIdentifiers.MODEL_CATERING,
            directory: MODEL_DIRECTORY,
            fileName: 'catering_themed.glb',
            scaling: new Vec3(0.001,0.001,0.001)
        },
        {
            id: AssetIdentifiers.MODEL_POUFS,
            directory: MODEL_DIRECTORY,
            fileName: 'seatingGroup_themed.glb',
            scaling: new Vec3(0.001,0.001,0.001)
        },
        {
            id: AssetIdentifiers.MODEL_PLANTS,
            directory: MODEL_DIRECTORY,
            fileName: 'Plants_themed.glb',
            scaling: new Vec3(0.001,0.001,0.001)
        },
        {
            id: AssetIdentifiers.MODEL_TABLETENNIS,
            directory: MODEL_DIRECTORY,
            fileName: 'tabletennis_themed.glb',
            scaling: new Vec3(0.001,0.001,0.001)
        },

    ],
    sounds: []
}
